module.exports = __webpack_public_path__ + "static/img/ctyoushileft.a3346d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyoushileft.png
// module id = JafA
// module chunks = 5